import { InfoIcon } from '@carboncopyco/icons';

export const EmptyState = () => {
  return (
    <div className="h-full flex flex-col gap-2.5 justify-center items-center">
      <span className="text-ds-primary-300">
        <InfoIcon size={20} />
      </span>
      <span className="w-[330px] text-sm text-ds-natural-600 text-center">
        To add a property to the form, select one from the JSON structure
      </span>
    </div>
  );
};
